import { useTranslations } from "next-intl";

import type { SuggestionsGroup } from "@/components/suggestions/types";
import type { PropsWithChildren } from "react";

type Props = {
  group: SuggestionsGroup;
  groupIndex: number;
  hideTitle?: boolean;
};

export function SuggestionGroupTitle({
  group,
  groupIndex,
  hideTitle,
  children,
}: PropsWithChildren<Props>) {
  const t = useTranslations("suggestions");
  const groupTitle = hideTitle ? "" : t(`popupGroups.${group.name}`);

  return (
    <>
      {!groupTitle && groupIndex !== 0 && (
        <hr className="mx-1.5 my-1 border-gray-200 dark:border-gray-600" />
      )}
      {groupTitle && (
        <div className="relative py-2 px-1.5 flex items-center">
          {groupIndex !== 0 && <hr className="w-full border-gray-200 dark:border-gray-600" />}
          <div className="font-mono text-xxs uppercase tracking-tight text-left font-light text-gray-500 pl-2 pr-1.25 absolute left-0 bg-white dark:bg-black">
            {groupTitle}
          </div>
        </div>
      )}
      {children}
    </>
  );
}
